import { Button } from '@mantine/core';
import { IconReportSearch } from '@tabler/icons-react';

interface OsintReportFilterProps {
    /** Whether the filter is active (only rows with a finished OSINT report are listed). */
    value: boolean;
    /** Fired with the new state when the toggle is pressed. */
    onChange: (value: boolean) => void;
}

/**
 * Toggle that narrows a catalog grid to rows with a finished OSINT report
 * (COMPLETED / PARTIAL_COMPLETED). Drives a SERVER-SIDE filter
 * (`has_osint_report=true`); sits beside the "No tenants" filter.
 */
export function OsintReportFilter({ value, onChange }: OsintReportFilterProps): React.JSX.Element {
    return (
        <Button
            variant={value ? 'light' : 'default'}
            leftSection={<IconReportSearch size={16} stroke={1.5} />}
            aria-pressed={value}
            onClick={() => {
                onChange(!value);
            }}
            data-testid="OsintReportFilterButton"
        >
            Has OSINT report
        </Button>
    );
}
